/*
 *******************************************************************************
 *
 *  Filename:   @/components/auth/RedirectReset.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Module for auth sign in reset password dialog
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Friday, August 18, 2023 - 6:07 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/08/18  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */
import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

function RedirectReset(props) {
  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Reset Password</DialogTitle>
      <DialogContent>
        <DialogContentText my={0}>
          Your password was reset by an administrator. Please proceed securely to reset your password.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.navigate("/auth/reset-password")} color="primary">
          Reset Password
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RedirectReset;
